export const selectOptionsEntityMemberTitle = [
  "Manager",
  "Member",
  "Officer",
  "Other",
];
